import { TRANSLATIONS_ARAB } from "./arab/translation";
import { TRANSLATIONS_EN } from "./en/translation";

export type languageType = "en" | "ar";

export const translations: Record<languageType, Record<string, string>> = {
  en: TRANSLATIONS_EN,
  ar: TRANSLATIONS_ARAB,
};
